/* assets/contact-home.js — inline scripts from the Contact page, in document order. */

(function(){
    var f=document.getElementById('ctForm'), card=document.getElementById('ctFormCard');
    if(f) f.addEventListener('submit', function(ev){ ev.preventDefault(); card.classList.add('is-done'); });
  })();